/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <Icon size={size} width={3.5}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)

/* SEARCH ICON */
export const SearchIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="10.8" cy="10.8" r="6.8" />
        <path d="M20.5 20.5 15.7 15.7" />
    </Icon>
)

/* FILTER ICON */
export const FilterIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3 6h18M6.5 12h11M10 18h4" />
    </Icon>
)

/* PLUS ICON — A NEW RESERVATION */
export const PlusIcon = ({ size = 16 }) => (
    <Icon size={size} width={2.6}>
        <path d="M12 5v14M5 12h14" />
    </Icon>
)

/* CALENDAR ICON — THE SECTION ITSELF AND THE PERIOD OF THE FILTER */
export const CalendarIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <rect x="3.5" y="5" width="17" height="15.5" rx="3" />
        <path d="M3.5 10h17M8.5 3v4M15.5 3v4" />
    </Icon>
)

/* CLOCK ICON — THE WINDOW OF A RESERVATION */
export const ClockIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3.5 2" />
    </Icon>
)

/* PLAYER ICON */
export const PlayerIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="9" cy="8" r="3.6" />
        <path d="M2.8 19.5c0-3.2 2.8-5.2 6.2-5.2s6.2 2 6.2 5.2" />
        <path d="M16.5 5.2a3.4 3.4 0 0 1 0 6.6M18 14.7c2.1.6 3.4 2.2 3.4 4.3" />
    </Icon>
)

/* VIP ICON — A CROWN, THE PLAYER IS MARKED IN Users */
export const VipIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3 7.5 6.5 11 12 4.5 17.5 11 21 7.5v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
    </Icon>
)

/* TABLE ICON — THE VIP GAME OF A RESERVATION */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="2.5" y="4.5" width="19" height="12" rx="4" />
        <path d="M8 20h8M12 16.5V20" />
    </Icon>
)

/* STUDIO ICON — THE GROUP OF A TABLE */
export const StudioIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4.5" width="18" height="12.5" rx="2.5" />
        <path d="M7 21h10M12 17v4" />
    </Icon>
)

/* OPERATOR ICON — WHOSE PLAYER SITS AT THE TABLE */
export const OperatorIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 20.5V6.5A2 2 0 0 1 6 4.5h6a2 2 0 0 1 2 2v14" />
        <path d="M14 10.5h4a2 2 0 0 1 2 2v8" />
        <path d="M2.5 20.5h19M7.5 8.5h3M7.5 12.5h3M7.5 16.5h3" />
    </Icon>
)

/* ADMIN ICON — WHO WROTE THE ROW */
export const AdminIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="8" r="3.8" />
        <path d="M4.5 20.5c0-3.6 3.4-5.8 7.5-5.8s7.5 2.2 7.5 5.8" />
    </Icon>
)

/* ARRIVED ICON — THE PLAYER CAME */
export const ArrivedIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M8.5 12.3 11 14.8l4.5-5" />
    </Icon>
)

/* MISSED ICON — THE WINDOW IS OVER AND NOBODY CAME */
export const MissedIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M9 9l6 6M15 9l-6 6" />
    </Icon>
)

/* CANCEL ICON — THE RESERVATION WAS CALLED OFF */
export const CancelIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M6.5 17.5 17.5 6.5" />
    </Icon>
)

/* LIVE ICON — THE WINDOW IS RUNNING RIGHT NOW */
export const LiveIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="3.2" />
        <path d="M6.2 6.2a8.2 8.2 0 0 0 0 11.6M17.8 17.8a8.2 8.2 0 0 0 0-11.6" />
    </Icon>
)

/* SESSION ICON — THE ENTRANCE THE RESERVATION WAS CLOSED WITH */
export const SessionIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4.5" width="18" height="10" rx="2.5" />
        <path d="M7.5 19.5h9M12 14.5v5" />
    </Icon>
)

/* COMMENT ICON — WHY THE TABLE WAS HELD */
export const CommentIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7a2.5 2.5 0 0 1-2.5 2.5H10l-4.5 4v-4H6.5A2.5 2.5 0 0 1 4 13.5Z" />
    </Icon>
)

/* LAYERS ICON — HOW MANY ROWS THE FILTER HOLDS */
export const LayersIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3 21 8l-9 5-9-5Z" />
        <path d="M3 13.5l9 5 9-5" />
    </Icon>
)

/* INFO ICON — THE HINT OF A SECTION */
export const InfoIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 7.6v.6" />
    </Icon>
)

/* STATUS ICON */
export const StatusIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 8v4.5l3 1.5" />
    </Icon>
)
